import {useNavigate} from "react-router-dom";
import {useEffect} from "react";

function LogoutScreen() {
    localStorage.clear()

    const navigate = useNavigate();

    useEffect(() => {
        navigate('/')
    }, [navigate]);

    return (
        <></>
    );
}

export default LogoutScreen;
